import { combineReducers } from 'redux'

import main from '../actions/main'

export default combineReducers({
  main
})
